import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './Receipt.less'

class Receipt extends Component {
    static propTypes = {
        children: PropTypes.object,
    };

    static defaultProps = {
        children: {}
    };

    render() {
        const {datetime, user_id, client_code, description, criteria, pages, cost} = this.props.children;

        return !!datetime && (
                <div className='receipt-module'>
                    <table>
                        <thead>
                        <tr>
                            <th colSpan="2">PACER Service Center</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <th>Receipt:</th>
                            <td>{ datetime }</td>
                        </tr>
                        <tr>
                            <th>User:</th>
                            <td>{ user_id }</td>
                        </tr>
                        <tr>
                            <th>Client:</th>
                            <td>{ client_code }</td>
                        </tr>
                        <tr>
                            <th>Description:</th>
                            <td>{ description }</td>
                        </tr>
                        <tr>
                            <td>&nbsp;</td>
                            <td>{ criteria }</td>
                        </tr>
                        <tr>
                            <th>Pages:</th>
                            <td>{ pages }&nbsp;(${ cost })</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            );
    }
}

export default Receipt


// WEBPACK FOOTER //
// ./src/components/Modules/Receipt/Receipt.js